<template>
  <div class="main-container">
      <div class="ordersIn hidden-sm-and-down">
        <div class="Xcontainer">
      <h4>
        <router-link v-if="this.$route.query.page!='p'" to="/Shopping">&lt;&lt;返回购物车</router-link>
      </h4>

      <div class="address">
        <h5>配送地址<span @click="editorAddress = true">新建地址</span></h5>
        <el-select v-if="address.length!=0" v-model="value" placeholder="请选择">
          <el-option
                  style="text-align: left;"
                  v-for="item in address"
                  :key="item.id"
                  :label="item.sheng+item.shi+item.xian+item.area+' '+item.recipients+' '+item.phone"
                  :value="item.id">
          </el-option>
        </el-select>

        <el-dialog title="收货地址" :visible.sync="editorAddress" center :before-close="handleClose">
          <el-form :model="ruleForm" size="mini" :rules="rules" ref="ruleForm" label-width="100px" class="下方输入详细地址" @submit.native.prevent>
            <el-form-item label="收件人" prop="name">
              <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model="ruleForm.name" placeholder="请输入收货人姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model.number="ruleForm.tel" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <el-form-item label="所在省市" prop="sheng" class="city">
              <el-select
                      v-model="ruleForm.sheng"
                      @change="choseProvince"
                      placeholder="省级地区">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
              <el-select
                      v-model="ruleForm.shi"
                      @change="choseCity"
                      :placeholder="shi">
                <el-option
                        v-for="item in shi1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
              <el-select
                      v-model="ruleForm.qu"
                      @change="choseBlock"
                      :placeholder="qu">
                <el-option
                        v-for="item in qu1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="addressDetails">
              <el-input v-model="ruleForm.addressDetails" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="邮编" prop="Zipcode">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model.number="ruleForm.Zipcode" placeholder="请输入邮编"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="payment">
        <h5>付款方式</h5>
        <div>
          <el-radio-group v-model="paymentRadio" @change="payment">
            <el-radio :label="1"><img src="../assets/wx-min.png" alt="">微信</el-radio>
            <!-- <el-radio :label="2"><img src="../assets/zfb-min.png" alt="">支付宝</el-radio> -->
          </el-radio-group>
        </div>
      </div>
      <div class="invoice">
        <h5>发票</h5>
        <div>
          <el-radio-group v-model="invoiceRadio" @change="invoice">
            <el-radio :label="0">无需发票</el-radio>
            <el-radio :label="1">个人发票</el-radio>
            <el-radio :label="2">公司发票</el-radio>
          </el-radio-group>
          <el-form :model="CompanyForm" :rules="CompanyRules" ref="CompanyForm" class="CompanyInvoice" label-width="80px">
            <el-form-item v-if="invoiceRadio==1" label="姓名" prop="yourNameInput" class="personal">
              <el-input v-model="CompanyForm.yourNameInput"></el-input>
            </el-form-item>
            <el-form-item v-if="invoiceRadio==2" label="公司名称" prop="companyNameInput" class="company">
              <el-input v-model="CompanyForm.companyNameInput"></el-input>
            </el-form-item>
            <el-form-item v-if="invoiceRadio==2" label="公司税号" prop="companyNumInput" class="company">
              <el-input v-model="CompanyForm.companyNumInput"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="orders">
        <h5 style="border-bottom:unset;margin:20px 0 0 0;">订单信息</h5>
        <div>

          <!--pc端显示-->
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" class="hidden-xs-only">
            <el-table-column label="">
              <template slot-scope="scope"><span><img class="cover" :src="imgsrc+scope.row[0].cover" alt=""></span></template>
            </el-table-column>
            <el-table-column label="商品信息">
              <template slot-scope="scope">
                <span>{{scope.row[0].name}}</span>
                <br/>
                <span class="taocan">{{scope.row[0].specs.group}}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">{{scope.row[0].num}}</template>
            </el-table-column>
            <el-table-column label="单价">
              <template slot-scope="scope"><span>￥{{scope.row[0].specs.price}}</span></template>
            </el-table-column>
            <el-table-column label="总计">
              <template slot-scope="scope"><span>￥{{ scope.row[0].num*scope.row[0].specs.price }}</span></template>
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24">
              <div class="submit_box">
                <span class="submit" @click="topay('CompanyForm')">提交订单</span>
                <p>
                  <span>共 <i>{{goodsNumber}}</i> 件商品</span>&nbsp;&nbsp;&nbsp;
                  <span>运费: ￥{{freight}}</span>&nbsp;&nbsp;&nbsp;
                  <span>总计: ￥<i>{{goodsPrice}}</i></span>
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-html="alipay" style="height: 0; opacity: 0;"> {{ alipay }} </div>
    </div>
  </div>

<!-- 手机端显示 -->
      
    <div class="hidden-md-and-up ordercontainer">
          <div class="citybox" v-show="address.length!==0">
            <span class="title">送至</span>
            <p v-show="item.id==value" v-for="(item ,index ) in address" :key="index">
            <el-dropdown trigger="click" @command="phoneAddressSelect"> 
              <span><b v-if="item.status==1">【默认】</b> {{ item.sheng }} {{ item.shi }} {{ item.xian }} {{ item.area }} {{item.recipients}} {{item.phone}} </span>
              <el-dropdown-menu slot="dropdown" class="phoneAddressMenu">
                <el-dropdown-item :command="indexs" v-for="(items ,indexs ) in address" :key="indexs">{{ items.sheng }} {{ items.shi }} {{ items.xian }} {{ items.area }} {{items.recipients}} {{items.phone}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> 
            </p>           
            <span class="title" @click="Creation" style="font-size: 0.32rem;color:#fff;background-color: #00383F;">新建地址</span>
          </div>

          <div class="sitebox" v-show="address.length==0" @click="Creation">
                +您当前没有任何收货地址
          </div>
         <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 95%;margin:0 auto;">
            <el-table-column label="" min-width="40%" style="float:left">
              <template slot-scope="scope">
                <div class="productimg"><img class="cover" :src="imgsrc+scope.row[0].cover" alt=""></div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope" class="productdetail">
                <p class="proname">{{scope.row[0].name}}</p>
                <p class="proprice">￥{{ (+ scope.row[0].specs.price).toFixed(2) }} <span>总计:￥{{ (scope.row[0].num*scope.row[0].specs.price).toFixed(2) }}</span></p>
                <p class="num">数量：{{ scope.row[0].num }}</p>
              </template>
            </el-table-column>
          </el-table>
          <div style="width:95%;margin:0 auto;height:1px;background: rgba(0, 56, 63, 0.5);"></div>
           <div class="mobpayment">
            <h5>付款方式</h5>
            <div>
              <el-radio-group v-model="paymentRadio" @change="payment">
                <el-radio :label="1"><img style="width:0.32rem" src="../assets/wx-min.png" alt=""><span style="vertical-align: top;">微信</span></el-radio>
                <!-- <el-radio :label="2"><img style="width:0.32rem" src="../assets/zfb-min.png" alt=""><span style="vertical-align: top;">支付宝</span></el-radio> -->
              </el-radio-group>
            </div>
          </div>
          <div style="width:95%;margin:0 auto;height:1px;background: rgba(0, 56, 63, 0.5);"></div>
          <div class="mobinvoice">
            <h5>发票</h5>
            <div>
              <el-radio-group v-model="invoiceRadio" @change="invoice">
                <el-radio :label="0">无需发票</el-radio>
                <el-radio :label="1">个人发票</el-radio>
                <el-radio :label="2">公司发票</el-radio>
              </el-radio-group>
              <el-form :model="CompanyForm" :rules="CompanyRules" ref="CompanyForm" class="CompanyInvoice" >
               <el-form-item v-if="invoiceRadio==1" label="姓名:" label-width="1rem" prop="yourNameInput">
                  <el-input style="width:50%" v-model="CompanyForm.yourNameInput"></el-input>
                </el-form-item>
                <el-form-item v-if="invoiceRadio==2" label="公司名称:" prop="companyNameInput">
                  <el-input style="width:50%" v-model="CompanyForm.companyNameInput"></el-input>
                </el-form-item>
                <el-form-item v-if="invoiceRadio==2" label="公司税号:" prop="companyNumInput">
                  <el-input style="width:50%" v-model="CompanyForm.companyNumInput"></el-input>
                </el-form-item>
              </el-form>
            </div>
      </div>
      <div style="width:95%;margin:0 auto;height:1px;background: rgba(0, 56, 63, 0.5);"></div>
      <div class="submit_mobbox">
        <p>
          <span>共 {{goodsNumber}} 件商品</span>
          <span>运费:￥{{freight}}</span>
          <span>总计:￥{{goodsPrice}}</span>
        </p>
        <div class="submit" @click="topay('CompanyForm')">提交订单</div>
      </div>
      <p style="font-size: 0.36rem;margin:0.4rem 0 0.98rem 0"><router-link to="/Shopping">返回购物车</router-link></p>
    </div>
  </div>
</template>

<script>
  import {regionData} from 'element-china-area-data'
  import { create_address_url,get_ship_address_url,product_detail_url,select_shopping_car_url,Destroy_shopping_car_url,addOrder_url} from '../request/api'
  export default {
    name: "ordersIn",
    data() {
      let validatePhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('电话号码不能为空！'))
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的电话号码'));
          }
        }
      };
      //邮编规则
      let validateZipcode = (rule, value, callback) => {
        if (!value) {
          // return callback(new Error('邮编不能为空！'))
          callback();//邮编可为空
        } else {
          const reg = /^[1-9][0-9]{5}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('邮政编码格式不正确！'));
          }
        }
      };
      let validateCompanyNum = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('公司税号不能为空！'))
        } else {
          const reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('公司税号格式不正确！'));
          }
        }
      };
      return {
        device: 1,//1pc,2mob
        options: regionData,
        cityIndex: 0,
        xianIndex: 0,
        shi: '市级地区',
        qu: '县级地区',
        shi1: [],
        qu1: [],
        selectshopId: '',
        tableData_temp: [[{
          name: '',
          cover: '',
          num: '',
          p_id: '',
          specs: {
            group: '',
            price: ''
          },
        }]],
        tableData: [],
        goodsPrice: 0,
        goodsNumber: 0,
        freight: 0,
        address: [],
        selectshopId: '',
        paymentRadio: 1,
        invoiceRadio: 0,
        editorAddress: false,
        value: 1,
        CompanyForm: {
          yourNameInput: '',
          companyNameInput: '',
          companyNumInput: '',
        },
        CompanyRules: {
          yourNameInput: [
            {required: true, message: '请输入你的姓名', trigger: 'blur'},
            {min: 1, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur'}
          ],
          companyNameInput: [
            {required: true, message: '请输入公司名称', trigger: 'blur'},
            {min: 1, max: 8, message: '长度在 2 到 8 个字符', trigger: 'blur'}
          ],
          companyNumInput: [
            {required: true, validator: validateCompanyNum, trigger: 'blur'},
          ],
        },
        ruleForm: {
          name: '',
          tel: '',
          city: '',
          addressDetails: '',
          Zipcode: '',
          sheng: '',
          shi: '',
          qu: '',
          E: '',
        },
        rules: {
          name: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'},
            {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
          ],
          tel: [
            {required: true, validator: validatePhone, trigger: 'blur'},
            { type: 'number', message: '电话必须为数字'}
          ],
          sheng: [
            {required: true, message: '请选择收货地址', trigger: 'change'},
          ],
          addressDetails: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur'}
          ],
          // Zipcode: [
          //   {required: false, validator: validateZipcode,  trigger: 'blur'},
          //   { type: 'number', message: '邮编必须为数字'}
          // ],
          Zipcode: [
            {required: false, validator: validateZipcode, trigger: 'blur'},
          ],
        },
        postParams: {},
        p_key: '',
        p_id: '',
        specs: '',
        num: '',
        alipay:'',
      }
    },
    methods: {
      skipClick(){
        this.$router.push({path:'/Information',query:{id:1,city:2}})
      },
      Creation(){
        this.$router.push({path:'/Addcity',query:{city:2}})
      },
      //生成订单
      addOrder(ordersdata) {
        addOrder_url(ordersdata).then((res)=>{
            let response_orders = res.data
            this.$cookies.remove('id');
            if (this.$route.query.page == 's') {
            this.deleteCar(this.p_key);
            }
            this.$cookies.remove('nowbuy');
            this.$refs['CompanyForm'].resetFields();
            this.$cookies.set('orders_data', response_orders.data);
            if (this.paymentRadio == 1) {
            if(this.device==1){
                this.$router.push({path: '/pay'});
            }else if(this.device==2){
              window.location.href = response_orders.data.url
            }
            } else if (this.paymentRadio == 2) {
              if (response_orders.code === 200) {
                  this.alipay = response_orders.data;
                  this.$nextTick(()=>{
                    document.forms['alipay_submit'].submit()
                  })
              }
            }
        })
     
      },
      //提交订单
      topay(formName) {
        console.log(this.address)
        if (this.address.length != 0) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (!this.$store.state.isLogin) {
                this.$router.push({path: '/login'});
              } else {
                if (this.invoiceRadio === 1) {
                  let ordersdata = {
                    p_id: this.p_id,
                    device:this.device,//设备
                    specs: this.specs,
                    num: this.num,
                    address: this.value,
                    invoice_status: 1,
                    pay_method: this.paymentRadio,
                    name: this.CompanyForm.yourNameInput
                  };
                  this.addOrder(ordersdata);
                } else if (this.invoiceRadio === 2) {
                  let ordersdata = {
                    p_id: this.p_id,
                    device:this.device,//设备
                    specs: this.specs,
                    num: this.num,
                    address: this.value,
                    invoice_status: 2,
                    pay_method: this.paymentRadio,
                    company: this.CompanyForm.companyNameInput,
                    shui_num: this.CompanyForm.companyNumInput
                  };
                  this.addOrder(ordersdata);
                } else {
                  let ordersdata = {
                    p_id: this.p_id,
                    device:this.device,//设备
                    specs: this.specs,
                    num: this.num,
                    address: this.value,
                    pay_method: this.paymentRadio,
                  };
                  this.addOrder(ordersdata);
                }
              }
            } else {
              return false;
            }
          });
        } else {
          this.$message.error("请添加收货地址")
        }
      },
      //选择支付方式
      payment(val) {
      },
      //发票
      invoice(val) {
      },

      //提交地址
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.$store.state.isLogin) {
              this.$router.push({path: '/login'});
            } else {
              let addressdata = {
                recipients: this.ruleForm.name,
                phone: this.ruleForm.tel,
                sheng: this.ruleForm.sheng,
                shi: this.ruleForm.shi,
                xian: this.ruleForm.qu,
                area: this.ruleForm.addressDetails,
                postcode: this.ruleForm.Zipcode
              };
              this.createAddress(addressdata);
            }
          } else {
            return false;
          }
        });
      },
      //创建地址
      createAddress(addressdata) {
        create_address_url(addressdata).then((res)=>{
          console.log(res)
              this.getaddress('submit');
              this.ruleForm.sheng = this.shi1 = this.ruleForm.shi = this.qu1 = this.ruleForm.qu = this.ruleForm.E = '';
              this.$refs['ruleForm'].resetFields();
              this.editorAddress = false;
        })
      
      },
      //取消
      resetForm(formName) {
        this.ruleForm.sheng = this.shi1 = this.ruleForm.shi = this.qu1 = this.ruleForm.qu = this.ruleForm.E = '';
        this.$refs[formName].resetFields();
        this.editorAddress = false;
      },
      //关闭表单弹窗
      handleClose() {
        this.ruleForm.sheng = this.shi1 = this.ruleForm.shi = this.qu1 = this.ruleForm.qu = this.ruleForm.E = '';
        this.$refs['ruleForm'].resetFields();
        this.editorAddress = false;
      },
      // 选省
      choseProvince: function (e) {
        for (var index2 in this.options) {
          if (e === this.options[index2].value) {
            this.ruleForm.sheng = this.options[index2].label;
            this.shi1 = this.options[index2].children;
            if (this.shi1 != undefined) {
              this.ruleForm.shi = this.options[index2].children[0].label;
              this.qu1 = this.options[index2].children[0].children;
              if (this.qu1 != undefined) {
                this.ruleForm.qu = this.options[index2].children[0].children[0].label;
                this.ruleForm.E = this.qu1[0].value;
              } else {
                this.ruleForm.E = this.ruleForm.qu = '';
                this.qu = '下方输入详细地址'
              }
            } else {
              this.ruleForm.E = this.ruleForm.qu = this.ruleForm.shi = '';
              this.shi = this.qu = '下方输入详细地址'
            }
            this.cityIndex = index2;
          }
        }
      },
      // 选市
      choseCity: function (e) {
        for (var index3 in this.options[this.cityIndex].children) {
          if (e === this.options[this.cityIndex].children[index3].value) {
            this.ruleForm.shi = this.options[this.cityIndex].children[index3].label;
            this.qu1 = this.options[this.cityIndex].children[index3].children;
            if (this.qu1 != undefined) {
              this.ruleForm.qu = this.options[this.cityIndex].children[index3].children[0].label;
              this.ruleForm.E = this.qu1[0].value;
            } else {
              this.ruleForm.E = this.ruleForm.qu = '';
              this.qu = '下方输入详细地址'
            }
            this.xianIndex = index3;
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        for (var index4 in this.options[this.cityIndex].children[this.xianIndex].children) {
          if (e === this.options[this.cityIndex].children[this.xianIndex].children[index4].value) {
            this.ruleForm.qu = this.options[this.cityIndex].children[this.xianIndex].children[index4].label;
          }
        }
      },
      //获取立即购买的商品
      nowBuy() {
        this.p_id = this.postParams.p_id;
        product_detail_url({id: this.p_id}).then((res)=>{
            let tableData_temp = res.data.data;
            this.tableData_temp[0][0].name = tableData_temp.name;
            this.tableData_temp[0][0].cover = tableData_temp.cover;
            this.tableData_temp[0][0].specs.group = tableData_temp.specs[this.postParams.arr_id].group;
            this.tableData_temp[0][0].specs.price = tableData_temp.specs[this.postParams.arr_id].price;
            this.tableData_temp[0][0].num = this.postParams.num;
            this.tableData_temp[0][0].p_id = this.postParams.p_id;

            this.tableData = this.tableData_temp;
            this.goodsNumber = parseInt(this.tableData[0][0].num);
            this.goodsPrice = this.tableData[0][0].num * this.tableData[0][0].specs.price + parseInt(this.freight);
            this.p_id = this.tableData[0][0].p_id + ',';
            this.num = this.tableData[0][0].num + ',';
            this.specs = JSON.stringify(this.tableData[0][0].specs) + ';';
        })
   
      },
      //获取选择商品
        selectShopping() {
        select_shopping_car_url({id: this.selectshopId}).then((res=>{
        this.tableData = res.data.data;
        for (var n = 0; n < this.tableData.length; n++) {
          this.goodsNumber += parseInt(this.tableData[n][0].num);
          this.goodsPrice += this.tableData[n][0].num * this.tableData[n][0].specs.price;
          this.p_key += this.tableData[n][0].id + ',';
          this.p_id += this.tableData[n][0].p_id + ',';
          this.num += this.tableData[n][0].num + ',';
          this.specs += JSON.stringify(this.tableData[n][0].specs) + ';';
          if (this.tableData[n][0].freight_status == 0) {
            if (this.tableData[n][0].freight >= this.freight) {
              this.freight = this.tableData[n][0].freight
            }
          }
        }
        this.goodsPrice += parseInt(this.freight);
        }))
      
      },
      //请求收货地址数据
     getaddress(submit) {
        get_ship_address_url().then((res)=>{
               if (res.data.data.length === 0) {
                this.address = [];
                } else {
                this.address = res.data.data;
                if (submit == 'submit') {
                    this.value = this.address[this.address.length - 1].id;
                } else {
                    for (var Xstatus = 0; Xstatus < this.address.length; Xstatus++) {
                    if (this.address[Xstatus].status == '1') {
                        this.value = this.address[Xstatus].id;
                        return;
                    } else {
                        this.value = this.address[0].id;
                    }
                    }
                }
            }
        })
     
      },
   deleteCar(id) {
        Destroy_shopping_car_url({detele_id: id}).then((res)=>{
        })
        this.$store.dispatch('getCarCount');
      },
    phoneAddressSelect(command){
      console.log(this.address)
      this.value=this.address[command].id
    }
    },
    mounted() {
      //设备
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        //移动端
        this.device=2;
      } else {
        //pc端
        this.device=1;
      }

      if (!this.$store.state.isLogin) {
        this.$router.push({path: '/login'});
      } else {
        if (this.$route.query.page == 's') {
          if (this.$cookies.isKey('id')) {//判断是否有cookie
            this.selectshopId = this.$cookies.get('id');//获取cookie
            //已选商品
            this.selectShopping();
            //已选商品end
          } else {
            this.$router.push({path: '/shopping'});
          }
        } else if (this.$route.query.page == 'p') {
          if (this.$cookies.isKey('nowbuy')) {
            this.postParams = this.$cookies.get('nowbuy');
            this.freight = this.postParams.freight
            this.freight_status = this.postParams.freight_status
            if (this.postParams.freight_status == 1) {
              this.freight = 0
            } else if (this.postParams.freight_status == 0) {
              this.freight = this.postParams.freight
            }
            this.nowBuy();
          } else {
            this.$router.push({path: '/Shopping'});
          }
        }else {
          this.$router.push({path: '/Product'});
        }
        //收货地址
        this.getaddress();
        //收货地址end
      }
    }
  }
</script>

<style lang="less" scoped>
.phoneAddressMenu.el-dropdown-menu{max-width: 97%!important;text-align: left;padding: 0;}
.phoneAddressMenu .el-dropdown-menu__item{color: #00383F;line-height: 1.7em;padding: .2rem;}
.phoneAddressMenu .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{background-color: #006566;color: #ffffff;}

/deep/.el-radio__input.is-checked+.el-radio__label{
  color:#00383F ;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #00383F;
    background: #00383F;
}
/deep/.el-dialog {
    width: 90%;
    max-width:800px;
}
/deep/.el-input--mini .el-input__inner{
  height: 40px;
}
  @-webkit-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0.2; }
    100% { opacity: 0.2; }
  }
  /* 定义blink类*/
  .blink{
    color: #dd2407;
    animation: blink 0.25s linear infinite;
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: blink 0.25s linear infinite;
    -moz-animation: blink 0.25s linear infinite;
    -ms-animation: blink 0.25s linear infinite;
    -o-animation: blink 0.25s linear infinite;
  }
.el-radio{
  color:#00383F;
}

/deep/.el-radio__inner{
  background-color: unset!important;
}
/deep/.el-radio__inner {
    border: 1px solid #00383F!important;
}
/deep/.el-radio__inner::after{
      width: 10px!important;
    height: 10px!important;
    border-radius: 100%!important;
    background-color: #00383F!important;
}
  .el-select-dropdown {
    border-color: #00383F;
    border-radius: 0;
    .el-select-dropdown__item.selected {
      color: #00383F;
    }
  }
  .el-select-dropdown[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #00383F;
    top: 0;
  }

  .ordersIn {
         width: 100%;
        color: #00383F;
        // min-height:calc(100vh - 300px);
    .Xcontainer {
        max-width: 1300px;
        width: 85%;
        margin: 0 auto;
      .submit_box {
        overflow: hidden;
        margin: 50px 0;
      }

      .submit_box > * {
        float: right;
        font-size: 18px;
        height: 100%;
        display: inline-block;
        padding: 10px 30px;
      }

      .submit {
        background-color: #00383F;
        color: #fff;
        cursor: pointer;
      }


      .el-input__inner {
        height: auto;
        padding: 0 10px;
        border-color: #666;
        border-radius: 0;
      }

      .el-select .el-input .el-select__caret {
        color: #000;
      }

      button {
        width: auto;
      }

      h4 {
        font-size: 22px;
        padding: 50px 0 20px;
        font-weight: normal;

        a {
          color: #00383F;
        }
      }

      text-align: left;

      h5 {
        border-bottom: 1px solid #00383F;
        padding: 10px 0;
        font-size: 18px;
        font-weight: normal;
        margin: 20px 0 30px;
      }

      .address {
        h5 {
          border-bottom: 0;
          margin-bottom: 0;
        
          span {
            float: right;
            margin-left: 20px;
            cursor: pointer;
          }
        }

        .el-select {
          width: 100%;
        }

      }

      i {
        font-style: normal;
      }

      .taocan {
        font-size: 13px;
        color: #00383F;
      }

      .cover {
        max-width: 120px;
      }

      .el-table td, .el-table th.is-leaf {
        border-bottom-color: #00383F;
      }

      .el-table__fixed-right::before,
      .el-table__fixed::before,
      .el-table--border::after,
      .el-table--group::after,
      .el-table::before {
        background-color: #00383F;
      }

      .el-table td {
        padding: 0;
      }

      .el-table td, .el-table th {
        text-align: center;
      }

      .el-table, .el-table thead {
        color: #00383F;
      }

      .el-radio__inner:hover {
        border-color: #00383F
      }

      .el-radio__input.is-checked + .el-radio__label {
        color: #00383F;
      }

      .el-radio__input.is-checked .el-radio__inner {
        border-color: #00383F;
        background: #00383F;
      }

      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: #00383F;
        font-weight: bold;
      }

      .el-button,
      .el-button:focus,
      .el-button:hover,
      .el-button--primary {
        background-color: #00383F;
        border-color: #00383F;
        border-radius: 0;
        color: #fff;
      }


      .payment img {
        width: 32px;
        margin-right: 6px;
        vertical-align: middle;
      }

      .invoice > div {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .CompanyInvoice {
        width: 50%;
        margin-left: 10px;

        .el-form-item {
          display: inline-block;
          width: 48%;
          max-width: 250px;
          float: left;
          margin: 5px 1%;
          font-size: 12px;

          .el-form-item__content {
            line-height: 1.8em;
          }

          .el-form-item__label {
            font-size: 13px;
            line-height: 2em;
            padding-right: 4px;
          }

          .el-input__inner {
            line-height: 1.7em;
          }
        }
      }

      ::-webkit-input-placeholder {
        color: #00383F;
      }

      :-moz-placeholder {
        color: #00383F;
      }

      ::-moz-placeholder {
        color: #00383F;
      }

      :-ms-input-placeholder {
        color: #00383F;
      }

      .city .el-cascader--mini {
        width: 100%;
      }

      .el-dialog {
        width: 90%;
        max-width: 600px;
      }

      .el-select.el-select--mini {
        width: 32.66%
      }

      .el-form-item.is-success .el-input__inner,
      .el-select .el-input.is-focus .el-input__inner,
      .el-input__inner:focus {
        border-color: #00383F;
      }
    }
  }

 @media (max-width: 991px) {
.ordercontainer{
width: 100%;
overflow: hidden;
font-weight: bold;
  .citybox{
    margin: 0.4rem  0.3rem;
    min-height: 1.7rem;
    border: 1px solid #00383F;
    overflow: hidden;
    display: flex;
    align-items: center;
    /deep/.el-dropdown{color: #00383F!important;line-height: 1.7em;}
    .title{
      display: inline-block;
      height: 1.7rem;
      float: left;
      writing-mode: vertical-lr;
      font-size: 0.45rem;
      font-weight: 900;
      padding-left: 0.1rem;
      padding-right: 0.1rem;
    }
    p{
      font-size: 0.24rem;
      text-align: left;
      padding: 0 .1rem;
    }
    i{
      font-size: 0.4rem;
      display: inline-block;
      margin-top: 0.65rem;
      font-weight: bold;
    }
  }
  .sitebox{
         margin: 0.4rem 0.3rem;
         height: 1.7rem;
         line-height: 1.7rem;
         border: 1px solid #00383F;
         font-size: 0.4rem;
         font-weight: 900;
        color: #00383F;
       }
.mobpayment{
  text-align: left;
  margin: 0 0.8rem;
  h5{
    font-size: 0.3rem;
    padding: 0.9rem 0 0.58rem 0;
  }
  /deep/.el-radio__inner{
    width: 0.21rem;
    height: 0.21rem;
    
  }
  /deep/.el-radio-group{
    margin-bottom: 0.9rem;
  }
  /deep/.el-radio__inner::after{
    width: 0.1rem!important;
    height: 0.1rem!important;
  }
  /deep/.el-radio__label{
      font-size: 0.24rem!important;
      height: 0.32rem!important;
      display: inline-block;
      line-height: 0.32rem;
      font-weight: bold;
      vertical-align: bottom;
      img{
        margin: 0 0.09rem 0 0.13rem;
      }
  }
}
.submit_mobbox{
  padding: 0 0.3rem;
  margin-top: 2rem;
  p{
    font-size: 0.3rem;
    margin: 0.4rem 0.19rem;
    text-align: center;
    font-weight: bold;
  }
  .submit{
    width: 100%;
    height: 0.9rem;
    background: #00383F;
    color: #fff;
    line-height: 0.9rem;
    font-size: 0.36rem;
    margin-bottom: 0.4rem;
  }
}
.mobinvoice{
   text-align: left;
  margin: 0 0.8rem;
   h5{
    font-size: 0.3rem;
    padding: 0.9rem 0 0.58rem 0;
  }
 
  /deep/.el-radio-group{
    margin-bottom: 0.6rem;
    font-weight: bold;
  }
 .company{
   width: 3rem;
 }
 /deep/.el-form-item__label{
   width:auto!important;
   line-height: 0.4rem;
   text-align: left;
   font-size: 0.24rem;
 }
 /deep/.el-input__inner{
   line-height: 0.4rem!important;
   height: 0.4rem;
 }
 /deep/.el-radio{
   margin-right: 0.2rem;
 }
 .personal{
   width: 50%;
 }
 /deep/.el-form-item__content{
   line-height: 0.4rem;
 }

}

     /deep/.el-table thead{
     display: none;
   }
    /deep/.el-table__row{
   td:nth-child(2){


     .cell{
        min-height: 2rem;
        padding: unset;
        text-align: left;
        line-height: unset;
        padding-left: 0.5rem;
          .proname{
          font-size: 0.32rem;
          padding-top: 0.1rem;
          font-weight: bold;
        }
        .proprice{
          font-size: 0.24rem;
          margin-top: 0.42rem;
          margin-bottom: 0.45rem;
          font-weight: bold;
          span{
            display: inline-block;
            margin-left: 0.6rem;
            vertical-align: unset;
          }
        }
        .num{
            font-size: 0.24rem;
            font-weight: bold;
        .el-button--small{
          margin-left: 0.5rem;
        }
        }
     }
   }
 }
//  /deep/.el-table .cell{
//    height: 2rem;
//  }
/deep/.el-table .el-table__cell{
  padding: 0.3rem 0 0.6rem 0;
}
/deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #EBEEF5!important;
}
    .productimg{
             width: 1.367rem;
              height: 2rem;
              background: url(../../static/mobile/product.png) no-repeat;
              background-size: 100% 100%;
              border: 1px solid #00383F ;
              margin-left: 0.56rem;
              img{
                width: 100%;
                padding-top: 0.27rem;
              }
      }

  .productdetail{
    text-align: left;
  
  }
}
 }
</style>



// WEBPACK FOOTER //
// src/view/OrdersIn.vue